import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Select from 'react-select';
import useData from '@/utils/useData';
import i18n from 'i18n';
import {FormikProps} from 'formik';
import {EvaluationTask} from '@/views/admin/channel/types';
import {buildURL} from '@/utils/urlBuilder';

type Option = { value: string; label: string };

type Props = {
    formik: FormikProps<EvaluationTask>;
    channelId?: number;
    channelEventTypeId?: number;
};

const EvaluationTaskFsTextFormFields: React.FC<Props> = React.memo(({
    formik,
    channelId,
    channelEventTypeId,
}) => {
    const [langFieldChoices] = useData<Option[]>(
        channelEventTypeId ? buildURL('langFieldChoices', {obj_id: channelEventTypeId}) : null,
        'langFieldChoices',
    );
    const [tagFieldChoices] = useData<Option[]>(window.URLS.tagFieldChoices, 'tagFieldChoices');
    const [partsToEvaluateChoices] = useData<Option[]>(
        channelId ? buildURL('partsToEvaluateChoices', {obj_id: channelId}) : null,
        'partsToEvaluateChoices',
    );

    return (
        <>
            <Row>
                <Col xs={12}>
                    <Form.Group className="mb-3" controlId="params.key" >
                        <Form.Label> {i18n.t('jt_key.text')}</Form.Label>
                        <Form.Control
                            type="text"
                            value={formik.values.params.key}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="params.key"
                            required
                            autoFocus
                            isInvalid={formik.touched.params?.key && !!formik.errors.params?.key}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.params?.key}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row >

            <Row>
                <Col xs={12}>
                    <Form.Group className="mb-3" controlId="params.tag" >
                        <Form.Label> {i18n.t('jt_tag.text')}</Form.Label>
                        <Select
                            value={tagFieldChoices?.find((x) => x.value === formik.values.params.tag) || null}
                            onChange={(v) => formik.setFieldValue('params.tag', (v as Option).value)}
                            onBlur={formik.handleBlur}
                            name="params.tag"
                            required
                            isSearchable={false}
                            options={tagFieldChoices}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.params?.tag}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row >

            <Row>
                <Col xs={12}>
                    <Form.Group className="mb-3" controlId="params.language" >
                        <Form.Label> {i18n.t('jt_language.text')}</Form.Label>
                        <Select
                            value={langFieldChoices?.find((x) => x.value === formik.values.params.language) || null}
                            onChange={(v) => formik.setFieldValue('params.language', (v as Option).value)}
                            onBlur={formik.handleBlur}
                            name="params.language"
                            required
                            isSearchable={false}
                            options={langFieldChoices}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.params?.language}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row >

            <Row>
                <Col xs={12}>
                    <Form.Group className="mb-3" controlId="params.partsToEvaluate" >
                        <Form.Label> {i18n.t('jt_parts_evaluate.text')}</Form.Label>
                        <Select
                            value={partsToEvaluateChoices?.find((x) => x.value === formik.values.params.partsToEvaluate) || null}
                            onChange={(v) => formik.setFieldValue('params.partsToEvaluate', (v as Option).value)}
                            onBlur={formik.handleBlur}
                            name="params.partsToEvaluate"
                            required
                            isSearchable={false}
                            options={partsToEvaluateChoices}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.params?.partsToEvaluate}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row >
        </>
    );
});

export default EvaluationTaskFsTextFormFields; 